<template>
  <div class="home">
    <!-- 视频 -->
    <div class="vido">
      <video-player
        class="video-player-box"
        style="width:100%; height:100%; position:fixed; left:0; top:0;"
        :options="playerOptions"
        :playsinline="true"
        ref="videoPlayer"
      />
      <div class="nav_logo">
        <img src="../assets/logo.png" class="logo"/>
      </div>
      <!-- <div class="dark_cover"></div> -->  
      <div class="play_img" v-if="show">
        <img src="../assets/play.png" class="play" @click.stop="isplay"/>
      </div>
      <div class="pause_img" v-else @click.stop="ispause">
      </div>
      <div class="nav_box">
          <div class="down_box">
            <span class="down_btn" @click="isDown">
              开始制作
            </span>
          </div>
        </div>     
    </div>
  </div>
</template>

<script>
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import { Base64 } from "js-base64";
import wx from "weixin-js-sdk";
import html2canvas from "html2canvas";

import Icon from "vant/lib/icon";
import Dialog from "vant/lib/dialog";
import Search from "vant/lib/search";
import List from "vant/lib/list";
import Button from "vant/lib/button";
import Cell from "vant/lib/cell";
import Popup from "vant/lib/popup";

import "vant/lib/icon/style";
import "vant/lib/dialog/style";
import "vant/lib/search/style";
import "vant/lib/list/style";
import "vant/lib/button/style";
import "vant/lib/cell/style";
import "vant/lib/popup/style";
document.title = "鱼腥草"
export default {
  components: {
      videoPlayer,
    "van-popup": Popup,
    "van-icon": Icon,
    "van-dialog": Dialog,
    "van-search": Search,
    "van-list": List,
    "van-cell": Cell,
    "van-button": Button
  },

  data() {
    return {
      data: null,
      isIos: false,
      isAndroid: false,
      // 视频播放器
      playerOptions: {
        // videojs options
        controls:false, //默认控制条
        muted: false, // 默认情况下将会消除任何音频。
        autoplay: false, //如果true,浏览器准备好时开始回放
        loop: true, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为
        language: "zh-CN",
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        sources:"", //视频地址
        // poster:
        //   "https://obj.pipi.cn/friday/7d13ad1127f0297dce3362dc279e0fdf.jpg",
        poster:"", //封面地址
        width: document.documentElement.clientWidth,
        height: document.documentElement.clientHeight,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, //当前时间和持续时间的分隔符
          durationDisplay: true, //显示持续时间
          remainingTimeDisplay: true,
          fullscreenToggle: true, // 全屏按钮
        },
      },
      show:true,
    };
  },
  watch: {},
  created() {
  },

  mounted() {
    let url = this.$route.query.s; //获取需要的值
    this.playerOptions.sources = Base64.decode(url); //解码
  },
  methods: {
    isplay(){
      this.show = false;
      this.$refs.videoPlayer.player.play() // 播放
    },
    ispause(){
      this.show = true;
      this.$refs.videoPlayer.player.pause() // 暂停
    },
    isDown() {
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      var isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1; // 微信内
      if (isAndroid) {
          let hidden =
          window.document.hidden ||
          window.document.mozHidden ||
          window.document.msHidden ||
          window.document.webkitHidden;
          if (typeof hidden == "undefined" || hidden == false) {
            // button.href="https://a.app.qq.com/o/simple.jsp?pkgname=com.ruanyiit.facefusion"
            // 上面的https是应用地址比如说应用宝，pkgname=应用名称
            window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.ruanyiit.facefusion"; //安卓应用市场地
          }
        }
        if (isIOS) {
          //如果是微信浏览器
          if(isWeixin){
            alert('请在浏览器上打开')
            return
          }
        //ios端
            let hidden =
            window.document.hidden ||
            window.document.mozHidden ||
            window.document.msHidden ||
            window.document.webkitHidden;
            if (typeof hidden == "undefined" || hidden == false) {
            // button.href="https://apps.apple.com/cn/app/你应用的名字/id11646468"
            // 上面的应用后面的id是你上传到appstore后，在App Store Connect的App信息界面会有一个Apple ID。添加到id后面即可。
            // window.location.href = "https://apps.apple.com/cn/app/换颜/id1600040585"; //app store地址
              window.location.href = "https://apps.apple.com/cn/app/id1600040585";


            }
        }
    },

  }
};
</script>

<style lang="less" scoped>
@import "../assets/iconfont/font_set_read_bar/iconfont.css";
@import "../styles/common.css";
@import "../styles/style.css";

/* 阻止文本复制 */
* {
  -o-user-select: none; /* 设置或检索是否允许用户选中文本 */
  -khtml-user-select: none; /* 苹果浏览器文本选择 */
  -webkit-user-select: none; /* 所有的文本选择 */
  -ms-user-select: none; /*IE浏览器*/
  user-select: none; /*用户是否能够选中文本*/
  -webkit-touch-callout: default; /* 系统默认浏览器长按链接与图片弹出菜单 */
}
.wrap {
  min-height: 100vh;
  /* background-color: white; */
}
.content-bg {
    width: 100vw;
    min-height: 100vh;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /* background: linear-gradient(to bottom,#ffc2d8,rgb(255, 255, 255)); */
    /* background-image: url("../assets/bg_2.png"); */
    background-size: cover;
  }
.content-bg img {
    -webkit-flex-shrink: 0;
    flex-shrink: 0;
    width: 100%;
    height: 100%;
}
.nav_logo{
  position: absolute;
  right: 5%;
  top: 2%;
  width:45px;
  height: 45px;
  z-index: 1002;
}
.nav_logo .logo{
  width:100%;
  height: 100%;
}
.nav_box {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 2%;
  width: 100%;
  z-index: 1002;
}
.flex_box {
  display: flex;
  align-items: center;
  justify-content: center;
}
.en_box {
  padding: 0 35px 19px 35px;
  text-align: left;
}
.studytip {
  display: block;
  font-size: 20px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: #3f99c4;
  line-height: 28px;
}
.study_title2 {
  display: block;
  font-size: 14px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: #333333;
  line-height: 30px;
}
.study_title3 {
  display: block;
  font-size: 12px;
  color: #959595;
  line-height: 30px;
}
.study_en {
  display: block;
  margin-bottom: 4px;
}
.study_tip {
  display: block;
  font-size: 12px;
  line-height: 20px;
  color: #959595;
}
.update_box {
  padding: 0 35px;
  margin-bottom: 22px;
  text-align: left;
}
.update_box span {
  display: block;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  white-space: pre-wrap;
}
.update_nav {
  height: 80px;
  overflow-y: auto;
}
.down_box {
  padding: 0 3%;
  color: #ffffff;
}
/* to right */
.down_btn {
  display: block;
  height: 44px;
  line-height: 44px;
  background: linear-gradient(96deg, #808DFB 0%, #E968C6 100%);
  border-radius: 5px;
  left: 0;
  bottom: 0;
}

.van-popup {
  min-height: 8%;
  /* box-shadow: 0px -2px 10px #ececec; */
}

.van-slider {
  margin: 0px 10px;
}
.zi-add::after {
  content: "-";
}
.zi-sub::after {
  content: "+";
}

.bold {
  line-height: 36px;
  font-weight: bold;
}
.fontWeight {
  font-weight: bold;
}

.padLR20 {
  padding: 0 20px;
  margin-top: 10px;
}

.van-icon-arrow::before {
  color: rgb(255, 107, 70);
  border-radius: 50%;
  content: "\F00A";
  background-color: white;
}
.home {
  width: 100vw;
  height: 100vh;
  object-fit: fill;
  video{
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
  .vido {
    width: 100vw;
    height: 100vh;
    position: relative;
    z-index: 1003;
    background: pink;

    /deep/.vjs-big-play-button {
        position: absolute;
        margin:auto;
        left:0;
        top:0;
        right: 0;
        bottom:0;
        width: 50px;
        height: 50px;
        border-radius: 50%;
      
    }
    /deep/.video-player-box {
        // display: flex;
        // align-items: center;
        // justify-content: center;
        width: 100%;
        height: 100%;
        touch-action: none;
        // .video-js .vjs-time-control {
        //     min-width: 0px;
        //     padding-left: 1px;
        //     padding-right: 1px;
        //     display: block;
        // }
        // .video-js .vjs-remaining-time {
        //     display: none;
        // }
        .video-js.vjs-fluid{
            height: 100%;
            .vjs-tech{
                object-fit: cover;
            }
        }
        // .dark_cover{
        //     position: fixed;
        //     width: 100%;
        //     height: 100%;
        //     background-color: rgba(0,0,0,0.6);
        //     z-index: -1;
        // }
    
    }
    .play_img{
      position: absolute;
      top: 0; 
      bottom:0; 
      left: 0; 
      right:0; 
      margin: auto;
      width:45px;
      height: 45px;
      background: #ffffff;
      border-radius: 50%;
      z-index: 1002;
    }
    .play_img .play{
      width:100%;
      height: 100%;
    }
    .pause_img{
      position: absolute;
      top: 0; 
      bottom:0; 
      left: 0; 
      right:0; 
      margin: auto;
      z-index: 1002;
    }
    
  }
}
</style>


// WEBPACK FOOTER //
// src/view/share.vue